<template>
  <div>
    <el-form ref="clueForm" :model="formData" :rules="rules" label-width="80px">
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item prop="storeId" label="归属门店">
            <QS-select
              v-model="formData.storeId"
              placeholder="请选择归属门店"
              filterable
              :optionData="storeList"
              :optionConfig="{labelKey: 'name', valueKey: 'id'}">
            </QS-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="name" label="姓名">
            <el-input v-model="formData.name" placeholder="请输入线索客户名称" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="phone" label="手机号">
            <el-input v-model="formData.phone" placeholder="请输入线索客户手机号" />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div class="dialog-footer">
      <el-button @click="cancelSave">取 消</el-button>
      <el-button type="primary" :loading="submitLoading" @click="saveFormData">确 定</el-button>
    </div>
  </div>
</template>
<script>
import { checkName, validateMobile } from '@/utils/validate'
import { saveNewClue } from '@/api/domain/orders'
import { storeList } from '@/api/domain/shop'

export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      formData: {
        name: '',
        phone: '',
        storeId: '',
      },
      storeList: [],
      submitLoading: false,
      rules: {
        name: [{ required: false, validator: this.validateName, trigger: 'blur' }],
        phone: [{ required: true, message: '请输入线索客户手机号', trigger: 'blur' }, { validator: validateMobile, trigger: 'blur' }],
        storeId: [{ required: true, message: '请选择归属门店', trigger: 'change' }],
      },
    }
  },
  watch: {
    dialogVisible(val) {
      if (val) {
        this.submitLoading = false
        this.formData = {
          name: '',
          phone: '',
          storeId: '',
        }
        this.$nextTick(() => {
          this.$refs.clueForm.clearValidate()
        })
      }
    },
  },
  mounted() {
    this.getStoreList()
  },
  methods: {
    validateName(rule, val, callback) {
      if (!val) callback()
      if (val.length > 30) {
        callback(new Error('长度不能超过30字符'))
      }
      checkName(rule, val, callback)
    },
    // 新建线索接口请求
    saveFormData() {
      if (this.submitLoading) return
      this.$refs.clueForm.validate((valid) => {
        if (!valid) return
        this.submitLoading = true
        const { phone, storeId, name } = this.formData
        const params = {
          name,
          phone,
          storeId,
        }
        saveNewClue(params).then(({ code }) => {
          if (code !== 1) {
            this.submitLoading = false
            return
          }
          this.$emit('success')
        }).catch(() => {
          this.submitLoading = false
        })
      })
    },
    // 获取公司下门店列表
    getStoreList() {
      storeList({
        pageNum: 1,
        pageSize: 9999,
      }).then(({ data }) => {
        this.storeList = data?.items || []
      })
    },
    cancelSave() {
      this.$emit('closeDialog')
    },
  },
}
</script>
<style lang="less" scoped>
  .dialog-footer {
    display: flex;
    justify-content: flex-end;
  }
</style>
